__turbopack_context__.v({
  "card": "I8zCsW_card",
  "cardHead": "I8zCsW_cardHead",
  "cardName": "I8zCsW_cardName",
  "cardReason": "I8zCsW_cardReason",
  "logo": "I8zCsW_logo",
  "logoFallback": "I8zCsW_logoFallback",
  "row": "I8zCsW_row",
  "scroller": "I8zCsW_scroller",
  "storyCard": "I8zCsW_storyCard",
  "storyTitle": "I8zCsW_storyTitle",
  "title": "I8zCsW_title",
});
